export default "__VITE_ASSET__JtyrUKsl__"